// Anchor scroll with sticky header offset (cross-browser, incl. Safari)
(function () {
  function getHeaderHeight() {
    var selectors = ['sticky-header', '#header-group', 'header-group', 'header', '.header'];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.offsetHeight > 0) return el.offsetHeight;
    }
    return 80;
  }

  function scrollToHash(hash) {
    var target = document.getElementById(hash);
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight() - 24;
    window.scrollTo(0, top);
  }

  // Same-page hash link clicks
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')) return;
    var hash = url.hash.slice(1);
    if (!hash || !document.getElementById(hash)) return;
    e.preventDefault();
    scrollToHash(hash);
    history.pushState(null, '', '#' + hash);
  });

  // Page loaded directly with a hash — override browser's default anchor scroll
  if (window.location.hash) {
    var hash = window.location.hash.slice(1);
    function doHashScroll() { scrollToHash(hash); }
    // Fire at multiple points to catch browser's scroll wherever it lands
    requestAnimationFrame(function () { requestAnimationFrame(doHashScroll); });
    setTimeout(doHashScroll, 50);
    setTimeout(doHashScroll, 150);
    setTimeout(doHashScroll, 400);
    window.addEventListener('load', function () { setTimeout(doHashScroll, 50); });
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll(".aos");

  const getAnimationClass = (el) => {
    if (el.classList.contains("aos-fade-up")) return "animate__fadeInUp";
    if (el.classList.contains("aos-fade-in")) return "animate__fadeIn";
    if (el.classList.contains("aos-fade-left")) return "animate__fadeInLeft";
    if (el.classList.contains("aos-fade-right")) return "animate__fadeInRight";
    return "animate__fadeInUp"; // default
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      el.classList.add("animate__animated", getAnimationClass(el));
      observer.unobserve(el);
    });
  }, { threshold: 0.2 });

  elements.forEach((el) => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", () => {
  const drawerNav = document.querySelector(".menu-drawer__navigation");
  if (!drawerNav) return;

  const parentItems = drawerNav.querySelectorAll(".menu-drawer__list-item--flat");

  parentItems.forEach((li) => {
    const childList = li.querySelector(":scope > .menu-drawer__menu--childlist");
    const parentLink = li.querySelector(":scope > a.menu-drawer__menu-item--mainlist");
    if (!childList || !parentLink) return;

    // Create toggle button
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "menu-drawer__submenu-toggle";
    btn.setAttribute("aria-label", "Toggle submenu");
    btn.setAttribute("aria-expanded", "false");
    btn.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 9l6 6 6-6"></path>
      </svg>
    `;

    // Insert toggle after the parent link
    parentLink.insertAdjacentElement("afterend", btn);

    // Collapse by default
    li.classList.remove("is-open");
    childList.style.display = "none";

    const toggle = () => {
      const isOpen = li.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", String(isOpen));
      childList.style.display = isOpen ? "block" : "none";
    };

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });

    // Optional: if you want tapping the parent title to toggle (instead of navigate)
    // Uncomment this block:
    /*
    parentLink.addEventListener("click", (e) => {
      e.preventDefault();
      toggle();
    });
    */
  });
});

// new variant code

document.addEventListener('DOMContentLoaded', function () {
  const fieldsetSelector =
    '[data-option-id="template-28852545749330__main-10684714451282-please-select-compound"]';

  const basePrice = 49900;
  const variantPrices = window.compoundVariantPrices || {};

  function getFieldset() {
    return document.querySelector(fieldsetSelector);
  }

  function getRadios() {
    const fieldset = getFieldset();
    return fieldset ? Array.from(fieldset.querySelectorAll('input[type="radio"]')) : [];
  }

  function getSelectedRadio() {
    return getRadios().find((radio) => radio.checked);
  }

  function getPriceEl() {
    return document.querySelector('[ref="priceContainer"] .price');
  }

  function getAddToCartBtn() {
    return document.querySelector('.add-to-cart-button');
  }

  function getBuyNowBtn() {
    return document.querySelector('.shopify-payment-button__button');
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateMainPrice() {
    const priceEl = getPriceEl();
    if (!priceEl) return;

    const selected = getSelectedRadio();

    if (!selected) {
      priceEl.textContent = formatMoney(basePrice);
      return;
    }

    const variantId = selected.dataset.variantId;
    const variantPrice = variantPrices[variantId];

    if (variantPrice) {
      priceEl.textContent = formatMoney(variantPrice);
    }
  }

  function updateButtonPrices() {
    const radios = getRadios();

    radios.forEach((radio) => {
      const variantId = radio.dataset.variantId;
      const label = radio.closest('.variant-option__button-label');
      const textEl = label ? label.querySelector('.variant-option__button-label__text') : null;

      if (!label || !textEl || !variantPrices[variantId]) return;

      const title = radio.value;
      const variantPrice = variantPrices[variantId];
      const uplift = variantPrice - basePrice;
      const priceDisplay = uplift > 0 ? `+ ${formatMoney(uplift)}` : formatMoney(variantPrice);

      textEl.innerHTML = `
        <span class="variant-option__button-title">${title}</span>
        <span class="variant-option__button-price">${priceDisplay}</span>
      `;

      if (radio.checked) {
        const titleEl = textEl.querySelector('.variant-option__button-title');
        const priceEl = textEl.querySelector('.variant-option__button-price');

        if (titleEl) titleEl.style.color = '#fff';
        if (priceEl) priceEl.style.color = '#fff';
      }
    });
  }

  function updatePurchaseButtons() {
    const selected = !!getSelectedRadio();
    const fieldset = getFieldset();
    const addToCartBtn = getAddToCartBtn();
    const buyNowBtn = getBuyNowBtn();

    if (fieldset) {
      fieldset.classList.toggle('no-variant-selected', !selected);
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !selected;
      addToCartBtn.textContent = selected ? 'Add to cart' : 'Select a compound';
      addToCartBtn.classList.toggle('is-disabled', !selected);
    }

    if (buyNowBtn) {
      buyNowBtn.disabled = !selected;
      buyNowBtn.style.pointerEvents = selected ? 'auto' : 'none';
      buyNowBtn.style.opacity = selected ? '1' : '0.5';
    }
  }

  function refreshUI() {
    updateMainPrice();
    updatePurchaseButtons();
  }

  function clearInitialSelection() {
    const radios = getRadios();

    radios.forEach((radio) => {
      radio.checked = false;
      radio.removeAttribute('checked');
      radio.setAttribute('data-current-checked', 'false');
    });
  }

  function resetGallerySlide() {
    // Override initial-slide to 0 on the product gallery slideshow.
    // This runs during DOMContentLoaded, BEFORE deferred module scripts execute and
    // before slideshow-component connects. The custom element reads initial-slide
    // when it connects, so setting it here ensures it starts at the natural first image.
    const slideshow = document.querySelector('media-gallery slideshow-component');
    if (!slideshow) return;
    slideshow.setAttribute('initial-slide', '0');
    // Handle the unlikely case it's already connected
    if (typeof slideshow.select === 'function') {
      slideshow.select(0, undefined, { animate: false });
    }
  }

  const fieldset = getFieldset();
  if (!fieldset) return;

  clearInitialSelection();
  refreshUI();
  resetGallerySlide();

  fieldset.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="radio"]')) return;

    refreshUI();
    requestAnimationFrame(refreshUI);
    setTimeout(refreshUI, 50);
    setTimeout(refreshUI, 150);
  });

  fieldset.addEventListener('click', function (e) {
    if (!e.target.closest('.variant-option__button-label')) return;

    requestAnimationFrame(refreshUI);
    setTimeout(refreshUI, 50);
    setTimeout(refreshUI, 150);
  });

  const form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!getSelectedRadio()) {
        e.preventDefault();
        alert('Please select a compound before adding to cart.');
        refreshUI();
      }
    });
  }
});